<template>
  <div class="svgBg">
    <!-- <div class="qiqiu2">
      <img src="../../../assets/logo_images/qiqiu2.png" alt="" />
    </div>
    <div class="zhezhao">1</div> -->
    <svg
      class="svg"
      width="1027"
      height="1027"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <!-- 底图 -->
      <image
        xlink:href="../../../assets/logo_images/svgBg.png"
        width="1027"
        height="1027"
      />
      <!-- 俩人 -->
      <image
        xlink:href="../../../assets/logo_images/people.png"
        width="39.5"
        height="52.6"
        y="240"
        x="570"
      />
      <!-- 球 -->
      <g id="pathAnimate">
        <image
          xlink:href="../../../assets/logo_images/qiu.png"
          width="14"
          height="14"
          y="310"
          x="404"
        >
          <animateMotion
            path="M 65 30 Q 10 10 10 60Z"
            dur="2s"
            repeatCount="indefinite"
          />
        </image>
      </g>

      <!-- 左-1 热气球 -->
      <g>
        <!-- <path
          fill="transparent"
          stroke="#000000"
          stroke-width="5"
          d="M100 -20 C 0 200, 250 300, 150 500"
          class="path"
        ></path> -->
        <image
          class="qiqiu2"
          xlink:href="../../../assets/logo_images/qiqiu2.png"
          width="95.5"
          height="165.7"
          y="400"
          x="90"
        >
          <!-- <animateMotion
            path="M400 -20 C 0 200, 250 300, 100 500"
            dur="2s"
            repeatCount="indefinite"
          /> -->
        </image>
      </g>
      <!-- 大雁 -->
      <image
        xlink:href="../../../assets/logo_images/bird.png"
        width="170"
        height="63"
        y="50"
        x="400"
        class="bird"
      />
      <!-- 左-2 热气球蓝 -->

      <image
        class="qiqiu3"
        xlink:href="../../../assets/logo_images/qiqiu3.png"
        width="90"
        height="160"
        y="600"
        x="360"
      />
      <!-- 右 热气球蓝 -->
      <g id="square_group">
        <image
          xlink:href="../../../assets/logo_images/qiqiu1.png"
          class="qiqiu1"
          width="72"
          height="125"
          y="110"
          x="840"
        />
      </g>
      <image
        xlink:href="../../../assets/logo_images/logo.png"
        class="logo"
        width="518"
        height="440"
        y="445"
        x="114"
      />
    </svg>
  </div>
</template>
<script>
  export default {
    data() {
      return {}
    },
    mounted() {
      // this.init()
    },
    methods: {
      init() {
        let anime = this.$animejs
        // form 动效card
        anime({
          targets: '.bird',
          translateX: [-300, 0],
          direction: 'alternate',
          loop: true,
          easing: 'linear',
          delay: anime.stagger(200),
        })
      },
    },
  }
</script>
<style lang="scss" scoped>
  .qiqiu3 {
    animation: smonth1 8s linear infinite;
  }
  .qiqiu2 {
    animation: smonth1 7s linear infinite;
  }
  .qiqiu1 {
    animation: smonth1 9s linear infinite;
  }
  @keyframes smonth1 {
    0% {
      transform: translateY(0);
    }
    5% {
      transform: translateY(-50px);
      z-index: 2;
    }
    50% {
      transform: translateY(-300px);
      z-index: 3;
    }
    100% {
      transform: translateY(-700px);
      z-index: 3;
    }
  }
  .bird {
    animation: aniBird 4s linear infinite;
  }
  @keyframes aniBird {
    0% {
      transform: scale(1) translate3d(70px, -100px, 0);
    }
    40% {
      transform: scale(1) translate3d(-100px, 0px, 0);
      opacity: 1;
    }
    60% {
      transform: scale(1) translate3d(-200px, 60px, 0);
      opacity: 1;
    }
    85% {
      transform: scale(1) translate3d(-300px, 95px, 0);
      opacity: 0.8;
    }
    86% {
      transform: scale(1) translate3d(-300px, 95px, 0);
      opacity: 0;
    }
    100% {
      transform: scale(1) translate3d(-310px, 150px, 0);
      opacity: 0;
    }
  }
</style>
